import { render } from "./InactiveScreen.vue?vue&type=template&id=72a7b7c5"
import script from "./InactiveScreen.vue?vue&type=script&lang=js"
export * from "./InactiveScreen.vue?vue&type=script&lang=js"

import "./InactiveScreen.vue?vue&type=style&index=0&id=72a7b7c5&lang=css"

import exportComponent from "/Users/peterdevos/Sites/progressive/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__